/* eslint-disable no-undef */

import React, {PureComponent} from 'react'
import {withStyles} from '@material-ui/core/styles/index';
import MobileStepper from "@material-ui/core/MobileStepper/index";
import KeyboardArrowLeft from "@material-ui/core/internal/svg-icons/KeyboardArrowLeft";
import KeyboardArrowRight from "@material-ui/core/internal/svg-icons/KeyboardArrowRight";
import Stepper from "@material-ui/core/Stepper/index";
import Step from "@material-ui/core/Step/index";
import StepButton from "@material-ui/core/StepButton/index";
import { Button } from '@material-ui/core';

const styles = theme => ({
    wrapper: {},
    rootSimple: {
        maxWidth: '100%',
        flexGrow: 1,
        margin: 'auto',
        paddingTop: 17,
        marginBottom: 0,
        textAlign: 'right'
    },
    root: {
        maxWidth: '100%',
        flexGrow: 1,
        margin: 'auto',
        marginTop: theme.spacing(0),
        marginBottom: theme.spacing(1) * -2,
        background: 'transparent',
        overflow: 'hidden',
    },
    button: {
        marginRight: theme.spacing(1),
    },
    backButton: {
        marginRight: theme.spacing(1),
        borderRadius: theme.borderRadius? theme.backButton.borderRadius: 10,
    },
    completed: {
        display: 'inline-block',
    },
    instructions: {
        marginTop: theme.spacing(1),
        marginBottom: theme.spacing(1),
    },
    stepText: {
        textAlign: 'center',
        fontWeight: '700',
        fontSize: '0.9rem',
        color: 'rgba(0, 0, 0, 0.54)',
        marginTop: 4,
        marginBottom: 4,
        ...theme.isMobile && {
            marginTop: 0,
            marginBottom: 0
        },
    },
    completedIcon: {
        background: 'blue',
        color: 'blue'
    }
});

function getStepContent(step) {
    return ''
    switch (step) {
        case 0:
            return 'Step 1: Select campaign settings...';
        case 1:
            return 'Step 2: What is an ad group anyways?';
        case 2:
            return 'Step 3: This is the bit I really care about!';
        default:
            return 'Unknown step';
    }
}


class QuestionPageStepper extends PureComponent {
    state = {
        activeStep: 0,
        completed: new Set(),
        skipped: new Set(),
    };

    componentWillMount() {
        const newStep = this.props.stepper.step - 1
        this.setToStep(newStep)
    }

    componentWillReceiveProps(nextProps) {
        const newStep = nextProps.stepper.step - 1
        if (this.state.activeStep !== newStep) {
            this.setToStep(newStep)
        }
    }

    setToStep = (step) => {
        const completed = new Set();
        for (let i = 0; i < step; i++) {
            completed.add(i);
        }
        this.setState({
            completed,
            activeStep: step,
        }, () => {
        });
    }


    totalSteps = () => getSteps().length;

    handleNext = () => {
        let activeStep;

        if (this.isLastStep() && !this.allStepsCompleted()) {
            // It's the last step, but not all steps have been completed
            // find the first step that has been completed
            const steps = getSteps();
            activeStep = steps.findIndex((step, i) => !this.state.completed.has(i));
        } else {
            activeStep = this.state.activeStep + 1;
        }
        this.setState({
            activeStep,
        });
    };


    skippedSteps() {
        return this.state.skipped.size;
    }

    isStepSkipped(step) {
        return this.state.skipped.has(step);
    }

    isStepComplete(step) {
        return this.state.completed.has(step);
    }

    completedSteps() {
        return this.state.completed.size;
    }

    allStepsCompleted() {
        return this.completedSteps() === this.totalSteps() - this.skippedSteps();
    }

    isLastStep() {
        return this.state.activeStep === this.totalSteps() - 1;
    }

    getSteps = (stepper) => {
        return Array(stepper.max).fill('');
    }

    render() {
        const {classes, stepper, next, previous} = this.props;
        const steps = this.getSteps(stepper);
        const {activeStep} = this.state;

        return (
            <div className={classes.wrapper}>
                {stepper.type === 'text' && <div className={classes.stepText}>
                    {stepper.preText} {stepper.step} / {stepper.max} {stepper.postText}
                </div>}
                {stepper.type === 'sm' && <MobileStepper
                    variant="dots"
                    style={{background: 'transparent', paddingRight: 0}}
                    steps={stepper.max}
                    classes={{
                        root: 'dot-stepper',
                        dotActive: 'dot-stepper-active-step',
                    }}
                    position="static"
                    activeStep={this.state.activeStep}
                    className={classes.rootSimple}
                    nextButton={false &&
                    <Button size="small" onClick={() => next()} disabled={this.state.activeStep === 5}>
                        {false && <KeyboardArrowRight/>}
                    </Button>
                    }
                    backButton={false &&
                    <Button size="small" onClick={() => previous()} disabled={this.state.activeStep === 0}>
                        {false && <KeyboardArrowLeft/>}
                    </Button>
                    }
                />}
                {stepper.type === 'lg' && <div className={classes.root}>
                    <Stepper alternativeLabel nonLinear activeStep={activeStep}
                             style={{background: 'transparent', padding: '8px 0 0px 0'}} className={'stepper'}>
                        {steps.map((label, index) => {
                            const props = {};
                            const buttonProps = {};
                            if (this.isStepSkipped(index)) {
                                props.completed = false;
                            }
                            return (
                                <Step key={label} {...props}
                                      classes={{
                                          root: 'step-wrapper',
                                      }}>
                                    <StepButton
                                        completed={this.isStepComplete(index)}
                                        classes={{
                                            root: 'step ' + (this.isStepComplete(index) ? 'completed-step' : '') + ' ' + (activeStep === index ? 'active-step' : ''),
                                            horizontal: 'step-line'
                                        }}
                                        {...buttonProps}
                                        style={{pointerEvents: 'none'}}
                                    >
                                    </StepButton>
                                </Step>
                            );
                        })}
                    </Stepper>
                </div>}
            </div>
        )
    }
}

export default withStyles(styles)(QuestionPageStepper);
